import React from 'react';
import {type SiteFilter, type Department} from '../types/types';
import ThemeDisplay from "../services/liferay/theme-display";

type AbcListProperties = {
	selectedFilter: SiteFilter;
	departments: Department[];
};

function AbcList({departments, selectedFilter}: Readonly<AbcListProperties>) {
	const [departmentsMap, setDepartmentsMap] = React.useState<Map<string, Department[]>>(new Map());

	React.useEffect(() => {
		const departmentsMap = new Map<string, Department[]>();
		const filteredDepartments = departments.filter(department => department.siteFilter.includes(selectedFilter));
		filteredDepartments.sort((a, b) => a.label.localeCompare(b.label, ThemeDisplay.getBCP47LanguageId(), {sensitivity: 'base'}));

		for (const department of filteredDepartments) {
			const firstLetter = department.label.charAt(0).toUpperCase();

			if (!departmentsMap.has(firstLetter)) {
				departmentsMap.set(firstLetter, []);
			}

			departmentsMap.get(firstLetter)?.push(department);
		}

		setDepartmentsMap(departmentsMap);
	}, [departments, selectedFilter]);

	return (<ul id='abc-list'>
		{Array.from(departmentsMap.keys()).map(letter => (
			<div key={letter} className='abc-block'>
				<div className='abc-letter' id={letter}>{letter}</div>
				{departmentsMap.get(letter)?.map(department => <p key={department.label}><a className='abc-site-link' href={getDepartmentHref(department)}>{department.label}</a></p>)}
			</div>
		))}
	</ul>);

	function getDepartmentHref(department: Department): string | undefined {
		const friendly = department.link;

		return (friendly.startsWith('/') ? '/web' : 'https://') + friendly;
	}
}

export default AbcList;
